import * as React from 'react';
import { flow, forEach, map } from 'lodash';
import {IBrandingState, II18nMessages } from '../../../../services/branding/models';
import {Col, ControlLabel, Form, FormGroup, HelpBlock, Modal, Row} from 'react-bootstrap';
import { Field, formValueSelector, InjectedFormProps, reduxForm, submit } from 'redux-form';
import { IChannel, ICustomer, IPostcodeAddress, IPremium, IProduct } from '../../../../data/api/models';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import FieldFormControl from '../../../../components/FieldFormControl';
import NavigationBar from '../../components/NavigationBar';
import { isLuhnHappy, isRequired, isLengthBetween, isEmail, isPhone, isPostcode } from '../../../../util/validators';
import Cards from 'react-credit-cards';
import FaExclamationTriangle from 'react-icons/fa/exclamation-triangle';
import DeclinesAndReferrals from '../../components/DeclinesAndReferrals';
import {getAvailableQuote, displayCurrency} from '../../../../util/helpers';
import {CheckboxField} from '../../../../components/CheckboxGroup/components/CheckboxField';
import FaInfoCircle = require('react-icons/lib/fa/info-circle');
import AddressLookUp from '../../../../components/AddressLookUp';

interface IPaymentFormProps extends InjectedFormProps {
  cvv: string;
  dispatch: any;
  password: string;
  cardName: string;
  cardBillingAddress: any;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  premium: IPremium;
  quote: IQuoteState;
  onBack: () => void;
  cardNumber: string;
  expiryYear: string;
  customer: ICustomer;
  i18n: II18nMessages;
  paymentType: string;
  expiryMonth: string;
  errorMessage: string;
  branding: IBrandingState;
  encryptCardNumber: string;
  policyDeclaration: boolean;
  passwordConfirmation: string;
  purchaseDeclaration: boolean;
  renderDefinition(name: string): any;
  handleCalculate: any;
  actions: {
    submit(name: string);
    push: (route: string) => void;
    quote: IQuoteActions;
  };
}

interface IPaymentFormState {
  activeField?: string;
  gross: number;
  referrals: any[];
  declines: any[];
  errors: string[];
  showAddressModel: boolean;
  termsCheck: boolean;
  firstCheck: boolean;
  showCardDetails: boolean;
}

class PaymentForm extends React.Component<IPaymentFormProps, IPaymentFormState> {
  public state = {
    activeField: null,
    gross: 0,
    declines: [],
    referrals: [],
    errors: [],
    showAddressModel: false,
    termsCheck: false,
    firstCheck: false,
    showCardDetails: true,
  };

  public componentDidMount() {
    const { change } = this.props;
    change('reuseCustomerAddress', true);
  }

  public componentWillReceiveProps(nextProps) {
    const { quote, dispatch, change } = this.props;

    const availableQuote = getAvailableQuote(quote);
    if (availableQuote.length) {
      dispatch(change('schemeId', availableQuote[0].scheme.id));
      this.setState({
        gross: availableQuote[0].gross,
      });
      if (quote.biannualFirstAmount) {
        this.setState({
          gross: quote.biannualFirstAmount,
        });
      }
    }
  }

  /*****************************
   Encrypt fields before submit
   ****************************/

  private encryptBeforeSubmit = () => {
    const { dispatch, change, cardNumber, cvv, actions, purchaseDeclaration } = this.props;
    // const encryptedCardNumber = this.encrypt(cardNumber);
    // const encryptedCardCvv = this.encrypt(cvv);
    if (!purchaseDeclaration) {
      this.setState({
        termsCheck: true,
      });
      return null;
    }

    const encryptedCardNumber = cardNumber;
    const encryptedCardCvv = cvv;

    return new Promise(() => {
      dispatch(change('card.cardNumber', encryptedCardNumber));
      dispatch(change('card.cvv', encryptedCardCvv));
      actions.submit('quote');
    });
  }

  private updateActiveField = (name) => () => {
    this.setState({
      activeField: name,
    });
  }

  private declinesOrReferrals() {
    const {declines, referrals, errors} = this.state;

    if (!declines.length && !referrals.length && !errors.length) {
      return null;
    }

    return (
      <div>
        <DeclinesAndReferrals
          declines={declines}
          referrals={referrals}
          errors={errors}
          quoteReference={this.props.quote.application.quoteReference}
          renewal={this.props.renewal}
        />
        {(! declines.length && ! referrals.length && errors.length) && (
          <NavigationBar
            hasBackButton={true}
            backTo={'/validation'}
            hasNextButton={false}
          />
        )}
      </div>
    );
  }

  // private isIE() {
  //   const ua = navigator.userAgent;
  //   /* MSIE used to detect old browsers and Trident used to newer ones*/
  //   return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
  // }

  private openAddressModal = () => {
    this.setState({
      showAddressModel: true,
    });
  }

  private closeAddressModal = () => {
    this.setState({
      showAddressModel: false,
    });
  }

  private handleTerms = (event) => {
    const { dispatch, change } = this.props;
    dispatch(change('purchaseDeclaration', event.target.value));
    this.setState({
      termsCheck: false,
    });
  }

  // private handleSelectCardHolderAddress = (address: IPostcodeAddress) => {
  //   const { dispatch, change } = this.props;
  //   const base = 'card.billing.address';
  //
  //   dispatch(change(`${base}.line1`, address.line1));
  //   dispatch(change(`${base}.line2`, address.line2));
  //   dispatch(change(`${base}.town`, address.town));
  //   dispatch(change(`${base}.county`, address.county));
  //   dispatch(change(`${base}.postcode`, address.postcode));
  // }
  //
  // private handleOnChange = (data, value) => {
  //   this.setState({ showCardDetails: !value });
  // }

  private renderAddressModal = () => {
    const { showAddressModel } = this.state;

    return (
      <Modal show={showAddressModel} onHide={this.closeAddressModal}>
        <Modal.Header
          closeButton={true}
          className="modal-background-black sub-content-container-alt"
          style={{ marginBottom: '0' }}
        >
          <div className="title-no-border">
            Data Protection Officer Address
          </div>
        </Modal.Header>
        <Modal.Body>
          <p>
            Data Protection Officer<br />
            MSIG Europe<br />
            The Leadenhall Building<br />
            122 Leadenhall Street<br />
            London<br />
            EC3V 4AG.
          </p>
        </Modal.Body>
      </Modal>
    );
  }

  public render() {
    const {
      cvv,
      quote,
      cardName,
      cardBillingAddress,
      cardNumber,
      expiryYear,
      handleSubmit,
      errorMessage,
      expiryMonth,
      channel,
    } = this.props;
    const { activeField, errors, termsCheck } = this.state;
    const quotes = quote.quotes.standard && quote.quotes.standard;
    const availableQuote = [];

    /**********************
     Normalize: max-length
    **********************/
    const lessThan = (limit) => (value, previousValue, allValues) => {
      return value.length < limit ? value : previousValue;
    };

    map(quotes, (quote, key) => {
      availableQuote.push(quote);
    });

    const declinesOrReferrals = this.declinesOrReferrals();
    if (declinesOrReferrals) {
      return declinesOrReferrals;
    }

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div className="steps-container">
          <div className="sub-content-container">
            <div className="sub-title">
              <h3>Confirmation and Purchase</h3>
            </div>
            <Row>
              <Col sm={12} className="payment-wording-size">
                <p>
                  This insurance is underwritten by MSIG Europe who is authorised and regulated by the
                  National Bank of Belgium. Authorised by the Prudential Regulation Authority. Subject to regulation by
                  the Financial Conduct Authority and limited regulation by the Prudential Regulation Authority. Details
                  about the extent of our regulation by the Prudential Regulation Authority and the Financial Conduct
                  Authority are available from us on request.
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm={12} className="payment-wording-size">
                <h4>Data Protection Notification</h4>
                <p><strong>Controller:</strong> MSIG Europe SE (hereafter “MSIG”) acts as the controller for the
                  processing of personal data for the purposes described below.</p>
                <p><strong>Purposes:</strong> Personal data is processed for the management and performance of the
                  pending or actual contract for insurance services including the management of the relationship with
                  the prospect or customer, managing claims and compliance with administrative, regulatory and legal
                  provisions applicable to us.</p>
                <p><strong>Sharing with third parties:</strong> MSIG may share personal data, if necessary for the
                  aforementioned purposes, and in accordance with applicable privacy laws, with other entities that
                  are part of the MSIG group as well as third parties when necessary for the execution of this pending
                  or actual contract (e.g., experts, insurance intermediaries, claims TPA), legally required (e.g.,
                  governments or judicial authorities) or if there is a legitimate interest.</p>
                <p><strong>Privacy rights, questions and complaints:</strong> If requested, to the extent legally
                  permissible, data subjects have the right to:</p>
                <ul>
                  <li>access his/her data, to have it rectified, if appropriate;</li>
                  <li>object the processing of his/her data, the right to have the processing of his/her data
                    restricted, as well as the right to have his/her data erased. In such cases, MSIG may not be able
                    to continue the contractual relationship.
                  </li>
                </ul>
                <p>To this end, the data subject may address a request to the Data Protection Officer (hereinafter,
                  "<strong>DPO</strong>") at the following email address: <a
                    href="mailto:privacy@msig-europe.com">privacy@msig-europe.com</a> or by post to: MSIG Europe SE,
                  attn. the DPO, Koning Albert-II laan 37, 1030 Brussels, Belgium.</p>
                <p>Complaints may be submitted to the relevant data protection supervisory authority.</p>
                <p><strong>Further information:</strong> More information on how MSIG protects personal data of data
                  subjects and how data subjects can exercise their rights can be found in MSIG Europe SE <a
                    href="https://msig-europe.com/data-privacy-notice" target="_blank">Data Privacy Notice</a>.</p>
              </Col>
            </Row>
            <Row>
              <Col sm={12} className="payment-wording-size">
                <h4>Motor Insurance Database</h4>
                <p>
                  Following UK legislation which implemented the Fourth EU Motor Directive, all UK motor insurance
                  details are now required to be held on a central database. This legislation places an obligation upon
                  you to ensure that the information stored on this database remains accurate and current at all times.
                  Consequently any delay or failure to update your records may cause you to be in breach of this
                  legislation which is a punishable offence.<br /><br />
                  I confirm that I will read my policy documents when I receive them.<br /><br />
                  You can cancel your policy within 14 day of purchase of your policy or within 14 day of
                  receiving your document, whichever is later. You will receive a full refund as long as your policy
                  has not started. Please contact Greenlands Insurance Services on {channel.phone} to arrange.
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm={12} className="payment-wording-size">
                <p>
                  <FormGroup controlId="purchase_declaration">
                    <div className="checkbox-payment">
                      <CheckboxField
                        meta={errors}
                        fields={
                          [
                            {
                              label: '',
                              name: 'purchaseDeclaration',
                            },
                          ]
                        }
                        handleOnChange={this.handleTerms}
                      />
                    </div>
                    <div className="check-box-label">
                      <strong>
                        I confirm I agree to the above terms and conditions.
                      </strong>
                    </div>
                    {termsCheck && (
                      <div className="has-error">
                        <HelpBlock><FaInfoCircle />
                          <strong>
                          {' '}Oops - You need to agree to the terms and conditions
                        </strong>
                        </HelpBlock>
                      </div>
                    )}
                  </FormGroup>
                </p>
              </Col>
            </Row>
            <div className="sub-title">
              <hr />
              <h3>Payment Details</h3>
            </div>

            {this.state.gross > 0 && (
              <div>
                <p>Total amount to pay: <span className="premium">&pound;{displayCurrency(this.state.gross)}</span>
                  {' '}(inc. Insurance Premium Tax (IPT))</p>

                {/*<div className="margin-bottom">*/}
                {/*  <Row>*/}
                {/*    <Col sm={4} style={{ paddingBottom: '10px' }}>*/}
                {/*      <Cards*/}
                {/*        cvc={cvv || ''}*/}
                {/*        focused={activeField}*/}
                {/*        name={cardName || ''}*/}
                {/*        number={cardNumber || ''}*/}
                {/*        expiry={(expiryMonth || '') + (expiryYear || '')}*/}
                {/*      />*/}
                {/*    </Col>*/}
                {/*    <Col sm={8} />*/}
                {/*  </Row>*/}
                {/*</div>*/}
                {/*<Row>*/}
                {/*  <Col sm={12}>*/}
                {/*    <p>*/}
                {/*      <FormGroup controlId="reuse_customer_address">*/}
                {/*        <div className="checkbox-payment">*/}
                {/*          <CheckboxField*/}
                {/*            meta={errors}*/}
                {/*            fields={*/}
                {/*              [*/}
                {/*                {*/}
                {/*                  label: '',*/}
                {/*                  name: 'reuseCustomerAddress',*/}
                {/*                },*/}
                {/*              ]*/}
                {/*            }*/}
                {/*            handleOnChange={this.handleOnChange}*/}
                {/*          />*/}
                {/*        </div>*/}
                {/*        <div className="check-box-label">*/}
                {/*          Are the cardholder details the same as the proposer's?*/}
                {/*        </div>*/}
                {/*      </FormGroup>*/}
                {/*    </p>*/}
                {/*  </Col>*/}
                {/*</Row>*/}

                {/*{this.state.showCardDetails && (*/}
                {/*  <>*/}
                {/*    <FormGroup controlId="card-holder form-group-half">*/}
                {/*      <Col componentClass={ControlLabel} sm={3}>*/}
                {/*        Cardholder Name:*/}
                {/*      </Col>*/}
                {/*      <Col sm={9} className="payment-group">*/}
                {/*        <Field*/}
                {/*          name="card.billing.name"*/}
                {/*          validate={[isRequired]}*/}
                {/*          component={FieldFormControl}*/}
                {/*          onFocus={this.updateActiveField('name')}*/}
                {/*          placeholder="Your Name"*/}
                {/*        />*/}
                {/*      </Col>*/}
                {/*    </FormGroup>*/}
                {/*    <FormGroup controlId="card-email form-group-half">*/}
                {/*      <Col componentClass={ControlLabel} sm={3}>*/}
                {/*        Cardholder Email:*/}
                {/*      </Col>*/}
                {/*      <Col sm={9} className="payment-group">*/}
                {/*        <Field*/}
                {/*          name="card.billing.email"*/}
                {/*          validate={[isRequired, isEmail]}*/}
                {/*          component={FieldFormControl}*/}
                {/*        />*/}
                {/*      </Col>*/}
                {/*    </FormGroup>*/}
                {/*    <FormGroup controlId="card-phone form-group-half">*/}
                {/*      <Col componentClass={ControlLabel} sm={3}>*/}
                {/*        Cardholder Phone:*/}
                {/*      </Col>*/}
                {/*      <Col sm={9} className="payment-group">*/}
                {/*        <Field*/}
                {/*          name="card.billing.phone"*/}
                {/*          validate={[isRequired, isPhone]}*/}
                {/*          component={FieldFormControl}*/}
                {/*        />*/}
                {/*      </Col>*/}
                {/*    </FormGroup>*/}
                {/*    <FormGroup controlId="postcode">*/}
                {/*      <Col componentClass={ControlLabel} sm={3}>*/}
                {/*        Cardholder Address:*/}
                {/*      </Col>*/}
                {/*      <Col sm={9} className="payment-group">*/}
                {/*        <Field*/}
                {/*          name="card.billing.address.postcode"*/}
                {/*          type="text"*/}
                {/*          className=""*/}
                {/*          component={AddressLookUp}*/}
                {/*          onSelectAddress={this.handleSelectCardHolderAddress}*/}
                {/*          validate={[*/}
                {/*            isRequired,*/}
                {/*            isPostcode,*/}
                {/*          ]}*/}
                {/*        />*/}
                {/*      </Col>*/}
                {/*    </FormGroup>*/}
                {/*    <FormGroup controlId="address">*/}
                {/*      <Row className="address-proposer-lines">*/}
                {/*        <Col sm={3} className="address-left-padding" />*/}
                {/*        <Col sm={9}>*/}
                {/*          {cardBillingAddress && cardBillingAddress.line1 ? cardBillingAddress.line1 : ''}*/}
                {/*        </Col>*/}
                {/*      </Row>*/}
                {/*      {cardBillingAddress && cardBillingAddress.line2 && (*/}
                {/*        <Row className="address-proposer-lines">*/}
                {/*          <Col sm={3} className="address-left-padding" />*/}
                {/*          <Col sm={9}>*/}
                {/*            {cardBillingAddress && cardBillingAddress.line2 ? cardBillingAddress.line2 : ''}*/}
                {/*          </Col>*/}
                {/*        </Row>*/}
                {/*      )}*/}
                {/*      <Row className="address-proposer-lines">*/}
                {/*        <Col sm={3} className="address-left-padding" />*/}
                {/*        <Col sm={9}>*/}
                {/*          {cardBillingAddress && cardBillingAddress.town ? cardBillingAddress.town : ''}*/}
                {/*        </Col>*/}
                {/*      </Row>*/}
                {/*      <Row className="address-proposer-lines">*/}
                {/*        <Col sm={3} className="address-left-padding" />*/}
                {/*        <Col sm={9}>*/}
                {/*          {cardBillingAddress && cardBillingAddress.county ? cardBillingAddress.county : ''}*/}
                {/*        </Col>*/}
                {/*      </Row>*/}
                {/*    </FormGroup>*/}
                {/*  </>*/}
                {/*)}*/}

                {/*<FormGroup controlId="card-number" className="margin-top">*/}
                {/*  <Col componentClass={ControlLabel} sm={3}>*/}
                {/*    Card Number:*/}
                {/*  </Col>*/}
                {/*  <Col sm={9} className="payment-group">*/}
                {/*    <Field*/}
                {/*      type="cleave"*/}
                {/*      name="cardNumber"*/}
                {/*      component={FieldFormControl}*/}
                {/*      validate={[isRequired, isLuhnHappy()]}*/}
                {/*      onFocus={this.updateActiveField('number')}*/}
                {/*      cleaveOptions={{ creditCard: true, creditCardStrictMode: true }}*/}
                {/*      placeholder="Card Number"*/}
                {/*    />*/}
                {/*  </Col>*/}
                {/*</FormGroup>*/}
                {/*<FormGroup controlId="expiry-dates form-group-half">*/}
                {/*  <Col componentClass={ControlLabel} sm={3}>*/}
                {/*    Expiry Date:*/}
                {/*  </Col>*/}
                {/*  <Col sm={4}>*/}
                {/*    <Row>*/}
                {/*      <Col sm={12} md={6} lg={3} className="expiry-date expiry-month">*/}
                {/*        <Field*/}
                {/*          placeholder="MM"*/}
                {/*          normalize={lessThan(3)}*/}
                {/*          validate={[isRequired]}*/}
                {/*          name={'card.expiryMonth'}*/}
                {/*          component={FieldFormControl}*/}
                {/*          onFocus={this.updateActiveField('expiry')}*/}
                {/*          className="mobile-bottom-padding mobile-expiry-width"*/}
                {/*        />*/}
                {/*      </Col>*/}
                {/*      <Col sm={12} md={6} lg={3} className="expiry-date expiry-year">*/}
                {/*        <Field*/}
                {/*          placeholder="YY"*/}
                {/*          normalize={lessThan(3)}*/}
                {/*          validate={[isRequired]}*/}
                {/*          name={'card.expiryYear'}*/}
                {/*          component={FieldFormControl}*/}
                {/*          className="mobile-expiry-width"*/}
                {/*        />*/}
                {/*      </Col>*/}
                {/*    </Row>*/}
                {/*  </Col>*/}
                {/*</FormGroup>*/}
                {/*<FormGroup controlId="cvv">*/}
                {/*  <Col componentClass={ControlLabel} sm={3}>*/}
                {/*    CVV/CSC:*/}
                {/*  </Col>*/}
                {/*  <Col sm={4}>*/}
                {/*    <Row>*/}
                {/*      <Col sm={12} md={6} lg={3}>*/}
                {/*        <Field*/}
                {/*          name="cvv"*/}
                {/*          normalize={lessThan(5)}*/}
                {/*          component={FieldFormControl}*/}
                {/*          onBlur={this.updateActiveField('')}*/}
                {/*          onFocus={!this.isIE() ? this.updateActiveField('cvc') : ''}*/}
                {/*          validate={[*/}
                {/*            isRequired,*/}
                {/*            isLengthBetween([3, 4], 'The CVC/CVV incorrect, please type it in again.'),*/}
                {/*          ]}*/}
                {/*          className="mobile-expiry-width"*/}
                {/*          placeholder="XXX"*/}
                {/*        />*/}
                {/*      </Col>*/}
                {/*    </Row>*/}
                {/*  </Col>*/}
                {/*</FormGroup>*/}
              </div>
            )}
          </div>

          <NavigationBar
            onClickSubmit={this.encryptBeforeSubmit}
            isInPaymentPage={true}
            hasBackButton={true}
            hasSaveButton={true}
            hasNextButton={this.state.gross > 0}
            backTo={'/quote'}
            {...this.props}
          />

          {errorMessage && (
            <div className="error-block-container">
              <FaExclamationTriangle/><p>{errorMessage}</p>
            </div>
          )}

          {this.renderAddressModal()}
        </div>
      </Form>
    );
  }
}

const validate = (values) => {
  return {};
};

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const cvv = selector(state, 'cvv');
      const quotes = state.quote.quotes;
      const channel = state.branding.channel;
      const password = selector(state, 'password');
      const schemeId = selector(state, 'schemeId');
      const errorMessage = state.quote.errorMessage;
      const cardName = selector(state, 'card.billing.name');
      const cardBillingAddress = selector(state, 'card.billing.address');
      const paymentInfo = selector(state, 'payment');
      const cardNumber = selector(state, 'cardNumber');
      const paymentType = selector(state, 'paymentType');
      const expiryYear = selector(state, 'card.expiryYear');
      const expiryMonth = selector(state, 'card.expiryMonth');
      const encryptCardNumber = selector(state, 'card.cardNumber');
      const policyDeclaration = selector(state, 'policyDeclaration');
      const passwordConfirmation = selector(state, 'passwordConfirmation');
      const purchaseDeclaration = selector(state, 'purchaseDeclaration');

      let premium = null;

      forEach(quotes, (tripTypes) => {
        forEach(tripTypes, (quotedPremium) => {
          if (quotedPremium.scheme.id === schemeId) {
            premium = quotedPremium;
          }
        });
      });

      return {
        cvv,
        premium,
        channel,
        schemeId,
        password,
        cardName,
        cardBillingAddress,
        expiryYear,
        cardNumber,
        paymentType,
        expiryMonth,
        paymentInfo,
        errorMessage,
        policyDeclaration,
        encryptCardNumber,
        passwordConfirmation,
        purchaseDeclaration,
      };
    },
    (dispatch) => ({
      dispatch,
      actions: {
        submit: bindActionCreators(submit, dispatch),
        push: bindActionCreators(push, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(PaymentForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Payment/index.tsx